import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { BasicModal } from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import AutocompleteWithCheckBoxes from '@HomaHealth/ui-component-library/lib/_AIQ-components/atoms/Autocomplete';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import React from 'react';

export interface EditPlanDocsProps {
  open: boolean;
  handleCancel: () => void;
  handleUpdate: () => void;
  title?: string | React.JSX.Element;
  selectedPlan: any;
  setSelectedPlan: React.Dispatch<any>;
  benefitTypeOptions: string[];
  planNameOptions: string[];
  vendorOptions: string[];
  reportOptions: string[];
}

const useStyles = makeStyles()({
  content: {
    borderRadius: '4px',
    background: patientAccessTheme.palette.grey[100],
    padding: '10px',
  },
  gridRow: {
    display: 'flex',
    flexDirection: 'row',
    gap: '16px',
    marginBottom: '16px',
  },
});

const EditPlanDocsModal: React.FC<EditPlanDocsProps> = ({
  open,
  title,
  handleCancel,
  handleUpdate,
  selectedPlan,
  setSelectedPlan,
  benefitTypeOptions,
  planNameOptions,
   
  vendorOptions,
  reportOptions,
}) => {
  const { classes } = useStyles();

  const handleFieldChange = async (field: string, value: string) => {
    setSelectedPlan((prev: any) => ({
      ...prev,
      [field]: value,
    }));
  };

  const getTypography = (label: string) => {
    return (
      <Typography
        fontSize="14px"
        lineHeight="22.4px"
        fontType="medium"
        textColor={patientAccessTheme.palette.text.mediumemphasis}
        margin="0px 0px 4px 0px"
      >
        {label}
      </Typography>
    );
  };

  return (
    <BasicModal
      open={open}
      title={title ?? 'Edit Plan Details'}
      body={
        <Grid className={classes.content}>
          <Grid className={classes.gridRow}>
            <Grid>
              {getTypography('Benefit Type(s)')}
              <AutocompleteWithCheckBoxes
                placeholder={
                  selectedPlan?.benefitTypes?.length === 0
                    ? 'Select Benefit Type(s)'
                    : ''
                }
                options={benefitTypeOptions ?? []}
                defaultValue={selectedPlan?.benefitTypes ?? []}
                handleChange={(
                  event: any,
                   
                  value: any,
                   
                  reason: any,
                   
                  details: any,
                ) => {
                  handleFieldChange('benefitTypes', value);
                }}
                noOptionsLabel="No Benefit Types Found"
                width="260px"
              />
            </Grid>
            <Grid>
              {getTypography('Plan Name(s)')}
              <AutocompleteWithCheckBoxes
                placeholder={
                  selectedPlan?.planNames?.length === 0
                    ? 'Select Plan Name(s)'
                    : ''
                }
                options={planNameOptions ?? []}
                defaultValue={selectedPlan?.planNames}
                handleChange={(
                  event: any,
                   
                  value: any,
                   
                  reason: any,
                   
                  details: any,
                ) => {
                  handleFieldChange('planNames', value);
                }}
                noOptionsLabel="No Plan Names Found"
                width="260px"
              />
            </Grid>
          </Grid>
          <Grid className={classes.gridRow}>
            {/* <Grid item>
              {getTypography('Vendor(s)')}
              <AutocompleteWithCheckBoxes
                placeholder={
                  selectedPlan?.vendors?.length === 0 ? 'Vendor(s)' : ''
                }
                options={vendorOptions ?? []}
                defaultValue={selectedPlan?.vendors}
                handleChange={(
                  event: any,
                  // eslint-disable-next-line no-unused-vars
                  value: any,
                  // eslint-disable-next-line no-unused-vars
                  reason: any,
                  // eslint-disable-next-line no-unused-vars
                  details: any,
                ) => {
                  handleFieldChange('vendors', value);
                }}
                noOptionsLabel="No Vendors Found"
                width="260px"
              />
            </Grid> */}
            <Grid>
              {getTypography('Analysis/Reports')}
              <AutocompleteWithCheckBoxes
                placeholder={
                  selectedPlan?.reports?.length === 0
                    ? 'Select Analysis/Reports'
                    : ''
                }
                options={reportOptions ?? []}
                defaultValue={selectedPlan?.reports}
                handleChange={(
                  event: any,
                   
                  value: any,
                   
                  reason: any,
                   
                  details: any,
                ) => {
                  handleFieldChange('reports', value);
                }}
                noOptionsLabel="No Analysis/Reports Found"
                width="260px"
              />
            </Grid>
          </Grid>
        </Grid>
      }
      width="auto"
      cancelButtonLabel={'Cancel'}
      confirmButtonLabel={'Update'}
      handleCancel={handleCancel}
      handleConfirm={handleUpdate}
      handleClose={handleCancel}
    />
  );
};

export default EditPlanDocsModal;
